import { Injectable, OnInit } from "@angular/core";
import { USER_DEFAULT_CURRENCY } from "../config/cashier.config";
import { Utility } from "../../shared/utility/utility";
import { CountryDataService } from "../../services/country.service";
import { UserDetailsService } from "../../services/user-details.service";
import * as $ from 'jquery';
import { CashierCommonService } from "./cashier.common.service";
import { EmitterService } from "../../services/emitter.service";

@Injectable({
  providedIn: "root",
})
export class BritePlayService implements OnInit{
  countryIP;
  isUserLoggedIn;
  userProfileDetails;
  transactionId;
  requestLoopCount = 0;
  requestCountForNewUser=0;
  isTxnCompleted = '';
  langCode = localStorage.getItem("langCode");
  constructor(
    private utils: Utility,
    private countryService: CountryDataService,
    private userDetailsService: UserDetailsService,
    private cashierCommonService:CashierCommonService,
    private emitterService:EmitterService) {
    
  }

  ngOnInit(): void {
    this.updateDefaultValues();
  }

  updateDefaultValues() {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    if (this.isUserLoggedIn) {
      this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
      this.countryIP = this.userProfileDetails["country"];
    } else {
      this.countryIP = this.countryService.IPCountry;
    }
    this.langCode = localStorage.getItem("langCode") ? localStorage.getItem("langCode") : "en";
  }

  getUserCurrency(){
    let currency = USER_DEFAULT_CURRENCY;
    if(this.isUserLoggedIn && this.userProfileDetails){
      currency = this.userProfileDetails.currency
    }
    return currency;
  }
  

 
  
  loadBriteScript(scriptUrl, signature){
    let node = document.createElement('script');
    node.src = scriptUrl;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    let self = this;
    
    node.onload = (res) => {   
      let interval = setInterval(() => {
          if($('#payment-iframe-container iframe') && $('#payment-iframe-container iframe').length){
           setTimeout(()=>{
            self.emitterService.boradCastCahsierPageChange('i-frame-page');
            clearInterval(interval);
           },1000)
           }
        }, 500);
      let briteObject = window['Brite'];
      let client = new briteObject(signature);
      client.start({
        selector: '#payment-iframe-container',
        style: {    
          background_color: "#aaaaff",    
          text_strong_color: "#335970",    
          text_weak_color: "#225560",    
          primary_color: "000000",    
          button_text_color: "#335970",    
          font_family: "Verdana",    
          selected_color: "#335970"
          }
          }, function(state) {
          self.isTxnCompleted  = '';
          if(state == briteObject.STATE_AUTHENTICATION_STARTED){
              console.log("AUTHENTICATION_STARTED");
          }
          if(state == briteObject.STATE_TRANSACTION_APPROVAL_STARTED){
              console.log("STATE_TRANSACTION_APPROVAL_STARTED");
          }
          if (state == briteObject.STATE_COMPLETED) {
            self.transactionId = localStorage.getItem("txnId");
            self.emitterService.boradCastCahsierPageChange('loading-page');
            self.cashierCommonService.getPNPUserFromTransaction(self.transactionId);
            self.isTxnCompleted = 'completed'
          }
        }, function() {
          if(self.isTxnCompleted == 'completed'){
            self.emitterService.boradCastCahsierPageChange('loading-page');
          }else{
            self.emitterService.boradCastCahsierPageChange('payment-details-page');
          }
          console.log("client closed");
          client.stop();
        });
      }

  }
  
  
}
